import { useLocation, useNavigate } from "react-router-dom";
import "./HeroSection.css";
import heroImage from '../../assests/salestology-img02.webp';
import heroImage2 from '../../assests/salestology-img00002.jpg';

const HeroSection = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const scrollToWhatWeOffer = (e) => {
        e.preventDefault();
        
        if (location.pathname !== '/') {
            navigate('/', { replace: true });
            setTimeout(() => {
                const element = document.getElementById('what-we-offer-section');
                if (element) {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }, 100);
        } else {
            const element = document.getElementById('what-we-offer-section');
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    };

    const heroStyle = {
        '--hero-image-desktop': `url(${heroImage})`,
        '--hero-image-mobile': `url(${heroImage2})`
    };

    return (
        <>
            <section className="hero" style={heroStyle}>
                <div className="hero-container">
                    <div className="hero-content">
                        <div className="hero-badge">WELCOME TO SALESTOLOGY</div>
                        <h1 className="hero-title">
                            We Grow<br />
                            <span className="hero-titlepart">Sales</span> 
                        </h1>
                        <p className="hero-section-subtitle">
                            A human and pragmatic approach to driving <span>sustainable sales growth</span>
                        </p>
                        <a href="#" className="hero-cta" onClick={scrollToWhatWeOffer}>Discover More</a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HeroSection;